export const toMuteISOString = (date: Date) =>
  date.toISOString().slice(0, -5) + 'Z';

export const handleScrollToTop = (id: string) => {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
  }
};
